import React from 'react';
import { Activity, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useWebhookStats } from '@/hooks/useWebhookStats';

export function WebhookStatsCards() {
  const { data: stats, isLoading } = useWebhookStats();

  const cards = [
    {
      label: 'Leads Hoje',
      value: stats?.totalToday ?? 0,
      icon: Activity,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
    {
      label: 'Taxa de Sucesso',
      value: `${stats?.successRate ?? 100}%`,
      icon: CheckCircle,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
    },
    {
      label: 'Tempo Médio',
      value: `${stats?.avgProcessingMs ?? 0}ms`,
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
    {
      label: 'Erros 24h',
      value: stats?.errorsLast24h ?? 0,
      icon: AlertTriangle,
      color: stats?.errorsLast24h ? 'text-red-600' : 'text-muted-foreground',
      bg: stats?.errorsLast24h ? 'bg-red-50' : 'bg-muted/50',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.label} className="border">
          <CardContent className="p-4">
            {isLoading ? (
              <Skeleton className="h-12 w-full" />
            ) : (
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${card.bg}`}>
                  <card.icon className={`h-5 w-5 ${card.color}`} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-foreground">{card.value}</p>
                  <p className="text-xs text-muted-foreground">{card.label}</p>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
